/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfUserDataDto } from '../../models/platform-api-result-of-user-data-dto';

export interface GetUserdataMine$Params {
}

export function getUserdataMine(http: HttpClient, rootUrl: string, params?: GetUserdataMine$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserDataDto>> {
  const rb = new RequestBuilder(rootUrl, getUserdataMine.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserDataDto>;
    })
  );
}

getUserdataMine.PATH = '/api/userdata/mine';
